// @ai-generated 2026-09-07T00:00:00+00:00 by niklas.eicker@tngtech.com using Claude Opus 5 (1M context)
import { Permission } from '@Constants/Permission.g';
import { useHasPermission } from '@Contexts/appContext';
import { useOfferStartedRun } from '@Hooks/AgenticOrchestrator/useOfferStartedRun';
import { useWorkflowByKey } from '@Hooks/AgenticOrchestrator/useWorkflowByKey';
import { useWorkflowDefinitionStory } from '@Hooks/AgenticOrchestrator/useWorkflowStory';
import { TableToolbarButton } from '@synqo/frontend-component-library';
import { IconPlayerPlay } from '@tabler/icons-react';
import { useCallback, useState } from 'react';
import { WorkflowRunStartModal } from './WorkflowRunStartModal';

export interface StartWorkflowButtonProps {
    /** The workflow's key, as it was seeded — e.g. `monthly_faktura`. */
    definitionKey: string;
    /** What the button does, as its tooltip and its accessible name. */
    label: string;
}

/**
 * Starts a named workflow from wherever the process it automates belongs.
 */
export function StartWorkflowButton({ definitionKey, label }: StartWorkflowButtonProps) {
    const hasPermission = useHasPermission();
    const mayExecute = hasPermission(Permission.AgenticOrchestratorWorkflowsExecute);

    const { workflow } = useWorkflowByKey(mayExecute ? definitionKey : '');
    const { view } = useWorkflowDefinitionStory(workflow?.id ?? '');

    const { offerStartedRun } = useOfferStartedRun();

    const [isOpen, setIsOpen] = useState(false);
    const open = useCallback(() => setIsOpen(true), []);
    const close = useCallback(() => setIsOpen(false), []);

    const started = useCallback(() => offerStartedRun(view?.title ?? label), [label, offerStartedRun, view?.title]);

    if (!mayExecute || workflow === undefined) {
        return null;
    }

    return (
        <>
            <TableToolbarButton
                icon={IconPlayerPlay}
                label={label}
                tooltip={label}
                onClick={open}
                locked={view === undefined}
            />
            {view && (
                <WorkflowRunStartModal
                    isOpen={isOpen}
                    onClose={close}
                    workflowDefinitionId={workflow.id}
                    title={view.title}
                    steps={view.steps}
                    onStarted={started}
                />
            )}
        </>
    );
}
